// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SiteRouteImport } from './routes/_site'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as SiteIndexRouteImport } from './routes/_site/index'
import { Route as SiteAboutRouteImport } from './routes/_site/about'
import { Route as SiteCareersRouteImport } from './routes/_site/careers'
import { Route as SiteContactRouteImport } from './routes/_site/contact'
import { Route as SitePrivacyPolicyRouteImport } from './routes/_site/privacy-policy'
import { Route as SiteReviewsRouteImport } from './routes/_site/reviews'
import { Route as SiteTermsRouteImport } from './routes/_site/terms'
import { Route as SiteBlogIndexRouteImport } from './routes/_site/blog/index'
import { Route as SiteBlogSlugRouteImport } from './routes/_site/blog/$slug'
import { Route as SiteConfirmSlugRouteImport } from './routes/_site/confirm/$slug'
import { Route as SiteLocationsIndexRouteImport } from './routes/_site/locations/index'
import { Route as SiteLocationsSlugRouteImport } from './routes/_site/locations/$slug'
import { Route as SiteProjectsIndexRouteImport } from './routes/_site/projects/index'
import { Route as SiteProjectsSlugRouteImport } from './routes/_site/projects/$slug'
import { Route as SiteServicesIndexRouteImport } from './routes/_site/services/index'
import { Route as SiteServicesGuttersRouteImport } from './routes/_site/services/gutters'
import { Route as SiteServicesRoofRepairRouteImport } from './routes/_site/services/roof-repair'
import { Route as SiteServicesRoofReplacementRouteImport } from './routes/_site/services/roof-replacement'
import { Route as SiteServicesSidingRouteImport } from './routes/_site/services/siding'
import { Route as SiteServicesStormDamageRouteImport } from './routes/_site/services/storm-damage'
import { Route as SiteServicesWindowsRouteImport } from './routes/_site/services/windows'

const SiteRoute = SiteRouteImport.update({
            id: '/_site',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const SiteIndexRoute = SiteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteRoute
          })
const SiteAboutRoute = SiteAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => SiteRoute
          })
const SiteCareersRoute = SiteCareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => SiteRoute
          })
const SiteContactRoute = SiteContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => SiteRoute
          })
const SitePrivacyPolicyRoute = SitePrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => SiteRoute
          })
const SiteReviewsRoute = SiteReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => SiteRoute
          })
const SiteTermsRoute = SiteTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => SiteRoute
          })
const SiteBlogIndexRoute = SiteBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => SiteRoute
          })
const SiteBlogSlugRoute = SiteBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => SiteRoute
          })
const SiteConfirmSlugRoute = SiteConfirmSlugRouteImport.update({
            id: '/confirm/$slug',path: '/confirm/$slug',getParentRoute: () => SiteRoute
          })
const SiteLocationsIndexRoute = SiteLocationsIndexRouteImport.update({
            id: '/locations/',path: '/locations/',getParentRoute: () => SiteRoute
          })
const SiteLocationsSlugRoute = SiteLocationsSlugRouteImport.update({
            id: '/locations/$slug',path: '/locations/$slug',getParentRoute: () => SiteRoute
          })
const SiteProjectsIndexRoute = SiteProjectsIndexRouteImport.update({
            id: '/projects/',path: '/projects/',getParentRoute: () => SiteRoute
          })
const SiteProjectsSlugRoute = SiteProjectsSlugRouteImport.update({
            id: '/projects/$slug',path: '/projects/$slug',getParentRoute: () => SiteRoute
          })
const SiteServicesIndexRoute = SiteServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => SiteRoute
          })
const SiteServicesGuttersRoute = SiteServicesGuttersRouteImport.update({
            id: '/services/gutters',path: '/services/gutters',getParentRoute: () => SiteRoute
          })
const SiteServicesRoofRepairRoute = SiteServicesRoofRepairRouteImport.update({
            id: '/services/roof-repair',path: '/services/roof-repair',getParentRoute: () => SiteRoute
          })
const SiteServicesRoofReplacementRoute = SiteServicesRoofReplacementRouteImport.update({
            id: '/services/roof-replacement',path: '/services/roof-replacement',getParentRoute: () => SiteRoute
          })
const SiteServicesSidingRoute = SiteServicesSidingRouteImport.update({
            id: '/services/siding',path: '/services/siding',getParentRoute: () => SiteRoute
          })
const SiteServicesStormDamageRoute = SiteServicesStormDamageRouteImport.update({
            id: '/services/storm-damage',path: '/services/storm-damage',getParentRoute: () => SiteRoute
          })
const SiteServicesWindowsRoute = SiteServicesWindowsRouteImport.update({
            id: '/services/windows',path: '/services/windows',getParentRoute: () => SiteRoute
          })





const SiteRouteChildren = {
  SiteAboutRoute: SiteAboutRoute,SiteCareersRoute: SiteCareersRoute,SiteContactRoute: SiteContactRoute,SitePrivacyPolicyRoute: SitePrivacyPolicyRoute,SiteReviewsRoute: SiteReviewsRoute,SiteTermsRoute: SiteTermsRoute,SiteIndexRoute: SiteIndexRoute,SiteBlogSlugRoute: SiteBlogSlugRoute,SiteConfirmSlugRoute: SiteConfirmSlugRoute,SiteLocationsSlugRoute: SiteLocationsSlugRoute,SiteProjectsSlugRoute: SiteProjectsSlugRoute,SiteServicesGuttersRoute: SiteServicesGuttersRoute,SiteServicesRoofRepairRoute: SiteServicesRoofRepairRoute,SiteServicesRoofReplacementRoute: SiteServicesRoofReplacementRoute,SiteServicesSidingRoute: SiteServicesSidingRoute,SiteServicesStormDamageRoute: SiteServicesStormDamageRoute,SiteServicesWindowsRoute: SiteServicesWindowsRoute,SiteBlogIndexRoute: SiteBlogIndexRoute,SiteLocationsIndexRoute: SiteLocationsIndexRoute,SiteProjectsIndexRoute: SiteProjectsIndexRoute,SiteServicesIndexRoute: SiteServicesIndexRoute
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)

const rootRouteChildren = {
  SiteRoute: SiteRouteWithChildren,AdminRoute: AdminRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)